/*
 * File: Modal.styles.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 21, 2022 at 12:38 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: June 3, 2024 at 10:20 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { IconButton } from '../IconButton';

// Constants
import { ContentNavTopbarHeight } from '../../styles/constants';


/**
 * Helpers
 */

const buildWidth = (variant) => {
	if (variant === 'standard') {
		return '520px';
	} if (variant === 'medium') {
		return '850px';
	} if (variant === 'large') {
		return '1000px';
	}
	return '90%';
};


/**
 * Styles
 */

export const ModalContainer = styled.div`
	position: fixed;
	z-index: 9999;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, ${({ showOverlay }) => (showOverlay ? 0.6 : 0)});
	opacity: 0;
	visibility: hidden;
	transform: scale(1.1);
	transition: visibility 0s linear 0.3s, opacity 0.3s 0s, transform 0.3s;
	overflow: scroll;
	overflow-x: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: ${ContentNavTopbarHeight}px 10px;
	pointer-events: none;

	&.show-modal {
		opacity: 1;
		visibility: visible;
		transform: scale(1);
		transition: visibility 0s linear 0s, opacity 0.3s 0s, transform 0.3s;
		pointer-events: ${({ showOverlay }) => (showOverlay ? 'inherit' : 'none')};
		overflow: hidden;
	}
	* {
		pointer-events: none !important;
	}
	&.show-modal * {
		pointer-events: all !important;
	}
`;

export const Modal = styled.div`
	position: relative;
	border-radius: 14px;
	background-color: ${({ theme }) => theme.primaryBackground};
	border: 1px solid ${({ theme }) => theme.layoutBorder};
	width: 94%;
	max-height: 94%;
	overflow: scroll;
	overflow-x: hidden;
	max-width: ${({ variant }) => buildWidth(variant)};
`;

export const CloseButton = styled(IconButton)`
	position: absolute;
	top: 20px;
	right: 20px;
	color: ${({ theme }) => theme.secondaryButton};
	z-index: 9;
`;

export const ModalWrapper = styled.div`
	padding: 35px 0px 0px;
`;

export const ActionOverlay = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
`;
